/**
 * Footer email-signup dual-write: fire Attentive (via BFF) on submit, then let
 * Shopify's {% form 'customer' %} proceed normally so CAPTCHA / accepts_marketing
 * still works.
 */
(function () {
  const ATTR_ENDPOINT = 'data-attentive-subscribe-url';
  const ATTR_ENABLED = 'data-attentive-subscribe';

  function getEmail(form) {
    const input = form.querySelector('input[type="email"][name="contact[email]"]');
    return input ? String(input.value || '').trim() : '';
  }

  function subscribeAttentive(url, email, shopifyId) {
    const body = { email: email };
    if (shopifyId) body.shopifyId = String(shopifyId);

    const payload = JSON.stringify(body);

    // Prefer fetch+keepalive; fall back to sendBeacon if fetch throws synchronously.
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: payload,
        credentials: 'omit',
        keepalive: true,
      }).catch(function (err) {
        console.warn('[email-signup-attentive] subscribe failed', err);
      });
      return;
    } catch (err) {
      console.warn('[email-signup-attentive] fetch error, trying sendBeacon', err);
    }

    try {
      if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        const blob = new Blob([payload], { type: 'application/json' });
        navigator.sendBeacon(url, blob);
      }
    } catch (beaconErr) {
      console.warn('[email-signup-attentive] sendBeacon failed', beaconErr);
    }
  }

  function bindBlock(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.attentiveBound === 'true') return;
    if (root.getAttribute(ATTR_ENABLED) !== 'true') return;

    const url = root.getAttribute(ATTR_ENDPOINT);
    if (!url) return;

    const form = root.querySelector('form.email-signup__form');
    if (!(form instanceof HTMLFormElement)) return;

    root.dataset.attentiveBound = 'true';
    const shopifyId = root.getAttribute('data-shopify-customer-id') || '';

    form.addEventListener('submit', function () {
      const email = getEmail(form);
      if (!email) return;
      subscribeAttentive(url, email, shopifyId);
    });
  }

  function init() {
    document.querySelectorAll('.email-signup-block[' + ATTR_ENABLED + '="true"]').forEach(bindBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
